// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
import { provideJupyterDesignSystem, jpSearch } from '@jupyter/web-components';
import { provideReactWrapper } from '@microsoft/fast-react-wrapper';
import React from 'react';
const { wrap } = provideReactWrapper(React, provideJupyterDesignSystem());
export const Search = wrap(jpSearch(), {
    events: {
        onChange: 'change',
        onInput: 'input'
    }
});
// @ts-expect-error unknown property
Search.displayName = 'Jupyter.Search';
